import { render, staticRenderFns } from "./son.vue?vue&type=template&id=1209e7d8&scoped=true&"
import script from "./son.vue?vue&type=script&lang=js&"
export * from "./son.vue?vue&type=script&lang=js&"
import style0 from "./son.vue?vue&type=style&index=0&id=1209e7d8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1209e7d8",
  null
  
)

export default component.exports